var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("x-grid", {
        ref: "grid",
        attrs: {
          id: "formList",
          rowId: _vm.rowId,
          "pager-config": _vm.pagerConfig,
          "form-config": _vm.formConfig,
          url: _vm.url,
          columns: _vm.columns,
          "checkbox-config": _vm.checkboxConfig,
          "toolbar-config": _vm.toolbarConfig,
          "print-config": _vm.printConfig,
          "import-config": _vm.importConfig,
          "export-config": _vm.exportConfig,
          "cell-click": _vm.chooseRow,
        },
        on: { "toolbar-addData": _vm.addRow, "toolbar-delData": _vm.delRow },
        scopedSlots: _vm._u(
          [
            {
              key: _vm.toolbarConfig.templatelSlots,
              fn: function () {
                return [
                  _c(
                    "vxe-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "DESIGN",
                          expression: "'DESIGN'",
                        },
                      ],
                      on: { click: _vm.designOnline },
                    },
                    [_vm._v("在线设计")]
                  ),
                  _c(
                    "btn-confirm",
                    {
                      staticStyle: { "margin-left": "15px" },
                      attrs: { title: "确定要部署吗?" },
                      on: { confirm: _vm.setRow },
                    },
                    [
                      _c(
                        "vxe-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "ARRANGE",
                              expression: "'ARRANGE'",
                            },
                          ],
                        },
                        [_vm._v("部署")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "a-modal",
        {
          attrs: {
            title: "模型管理",
            centered: "",
            footer: null,
            maskClosable: false,
            closable: true,
            visible: _vm.editModalVisible,
            width: 600,
          },
          on: { cancel: _vm.closeEdit },
        },
        [
          _vm.editModalVisible
            ? _c("formDetail", {
                ref: "detailForm",
                attrs: { rowId: _vm.editRowId },
                on: {
                  cancelled: function ($event) {
                    return _vm.closeEdit()
                  },
                  saved: function ($event) {
                    return _vm.closeEdit(true)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }